import { DomainEvent } from '../../../../core/domain/events/domain_event';
import { Task } from '../task';

export class TaskEvent extends DomainEvent<Task> {}

export class TaskCreatedEvent extends TaskEvent {}

export class TaskUpdatedEvent extends TaskEvent {}

export class TaskRemovedEvent extends TaskEvent {}
